import React, { useState } from 'react'
import type { TenantThemeConfig } from '../types/theme'
import './ModernHowtoPage.css'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

interface ModernHowtoPageProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

type HowtoSection = {
  id: string
  title: string
  subtitle: string
  icon: string
  steps: string[]
}

/** ข้อมูลคู่มือ — ตรง howto.html */
const HOWTO_SECTIONS: HowtoSection[] = [
  {
    id: 'one',
    title: 'สมัครสมาชิก',
    subtitle: 'เปิดบัญชีใช้งานครั้งแรก',
    icon: 'fas fa-user-plus',
    steps: [
      'กรอกข้อมูลของท่านลงในช่องว่างหมายเลขโทรศัพท์',
      'กำหนดรหัสผ่านที่ท่านต้องการใช้ในการเข้าสู่ระบบเพื่อทำรายการ ฝาก-ถอน',
      'กรอก ชื่อ-นามสกุล ของท่าน',
      'กรอกหมายเลขบัญชีธนาคารของท่าน',
      'เลือกธนาคารที่ท่านต้องการจะใช้ในการทำรายการกับเว็บของเรา',
      'กรอก ID LINE',
      'เลือกช่องทางที่ท่านรู้จักเรา',
    ],
  },
  {
    id: 'two',
    title: 'ทำรายการฝากเงิน',
    subtitle: 'เติมเครดิตเข้ากระเป๋า',
    icon: 'fas fa-wallet',
    steps: [
      'เข้าหน้าเว็บเลือก "เข้าสู่ระบบ" กรอก User และ Password แล้วกด "ล็อกอิน"',
      'เมื่อเข้าสู่ระบบเรียบร้อยแล้วเลือกที่เมนู "ฝากเงิน"',
      'โอนเงินตามหมายเลขบัญชีที่ทางเว็บระบุไว้',
      'เมื่อโอนเงินเรียบร้อยแล้วรอ 30 วินาที เครดิตจะเข้า User ของท่านโดยอัตโนมัติ',
      'ท่านสามารถเข้าเล่นได้ทันที',
    ],
  },
  {
    id: 'three',
    title: 'ทำรายการถอนเงิน',
    subtitle: 'ถอนเครดิตเข้าบัญชีธนาคาร',
    icon: 'fas fa-money-bill-wave',
    steps: [
      'เข้าหน้าเว็บเลือก "เข้าสู่ระบบ" กรอก User และ Password แล้วกด "ล็อกอิน"',
      'เมื่อเข้าสู่ระบบเรียบร้อยแล้วเลือกที่เมนู "ถอนเงิน"',
      'กรอกจำนวนเงินที่ท่านต้องการถอน',
      'หลังจากกรอกจำนวนเงินแล้วคลิกที่ "ดำเนินการ"',
      '***จำนวนเงินขั้นต่ำในการแจ้งถอนต้องมี 300 บาท ขึ้นไป***',
    ],
  },
  {
    id: 'four',
    title: 'การรับโบนัส',
    subtitle: 'กดรับโปรหลังฝากเงิน',
    icon: 'fas fa-gift',
    steps: [
      'เข้าหน้าเว็บเลือก "เข้าสู่ระบบ" กรอก User และ Password แล้วกด "ล็อกอิน"',
      'เมื่อเข้าสู่ระบบเรียบร้อยแล้วเลือกที่เมนู "โบนัส"',
      'ทุกโบนัสต้องกดรับหลังจากฝากเงินเท่านั้นห้ามเล่นก่อนเด็ดขาด',
      '***หากทีมงานตรวจสอบว่ามีการรับโบนัสเพื่อแทงสวน ทางทีมงานจะไม่ทำรายการถอนให้ทุกกรณี***',
    ],
  },
  {
    id: 'five',
    title: 'การแนะนำเพื่อน',
    subtitle: 'แชร์ลิงก์ รับคอมมิชชัน',
    icon: 'fas fa-user-friends',
    steps: [
      'เข้าหน้าเว็บเลือก "เข้าสู่ระบบ" กรอก User และ Password แล้วกด "ล็อกอิน"',
      'เมื่อเข้าสู่ระบบเรียบร้อยแล้วเลือกที่เมนู "แนะนำเพื่อน"',
      'กดปุ่มคัดลอกลิงค์ในช่องลิงค์แนะนำเพื่อนเพื่อนำไปแนะนำเพื่อน เมื่อเพื่อนสมัครผ่านลิงค์ท่านจะได้รับ 0.6 % จากยอดเทิร์นโอเวอร์ของเพื่อน',
      'แนะนำได้ไม่จำกัดจำนวน ยิ่งแนะนำเยอะ ยิ่งได้เยอะ',
    ],
  },
  {
    id: 'six',
    title: 'การรับเครดิตคืน',
    subtitle: 'รับเครดิตคืนตามเงื่อนไข',
    icon: 'fas fa-hand-holding-usd',
    steps: [
      'เข้าหน้าเว็บเลือก "เข้าสู่ระบบ" กรอก User และ Password แล้วกด "ล็อกอิน"',
      'เมื่อเข้าสู่ระบบเรียบร้อยแล้วเลือกที่เมนู "รับเครดิตคืน"',
      'กดปุ่มเพื่อรับเครดิตฟรีคืนท่านต้องมียอดการเล่นมากกว่า 15 บาท',
      'แนะนำให้อ่านเงื่อนไขกับกติกาให้ครบถ้วนด้วย',
    ],
  },
]

function isWarningStep(step: string) {
  return step.includes('***')
}

function cleanStepText(step: string) {
  return step.replace(/^\*+|\*+$/g, '').trim()
}

/** หน้าคู่มือ — ธีม HTD */
const ModernHowtoPage: React.FC<ModernHowtoPageProps> = () => {
  const [openId, setOpenId] = useState<string | null>('one')

  const openSection = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id))
    requestAnimationFrame(() => {
      document.getElementById(`howto-card-${id}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    })
  }

  return (
    <div className="content htd-howto">
      <div className="htd-howto__glow" aria-hidden />
      <div className="htd-howto__inner">
        <header className="htd-howto__hero htd-howto-anim htd-howto-anim--1">
          <div className="htd-howto__badge" aria-hidden>
            <i className="fas fa-book-open" />
          </div>
          <div className="htd-howto__hero-text">
            <p className="htd-howto__eyebrow">คู่มือการใช้งาน</p>
            <h1 className="htd-howto__title">เริ่มต้นใช้งานง่ายในไม่กี่ขั้นตอน</h1>
            <p className="htd-howto__desc">
              เลือกหัวข้อด้านล่างเพื่อดูวิธีสมัคร ฝาก ถอน รับโบนัส และสิทธิประโยชน์อื่นๆ
            </p>
          </div>
        </header>

        <nav className="htd-howto__chips htd-howto-anim htd-howto-anim--2" aria-label="หัวข้อคู่มือ">
          {HOWTO_SECTIONS.map((section, index) => {
            const active = openId === section.id
            return (
              <button
                key={section.id}
                type="button"
                className={`htd-howto__chip${active ? ' is-active' : ''}`}
                aria-pressed={active}
                onClick={() => openSection(section.id)}
              >
                <span className="htd-howto__chip-num">{index + 1}</span>
                <span className="htd-howto__chip-label">{section.title}</span>
              </button>
            )
          })}
        </nav>

        <div className="htd-howto__list htd-howto-anim htd-howto-anim--3">
          {HOWTO_SECTIONS.map((section, index) => {
            const isOpen = openId === section.id
            return (
              <article
                key={section.id}
                id={`howto-card-${section.id}`}
                className={`htd-howto__card${isOpen ? ' is-open' : ''}`}
              >
                <button
                  type="button"
                  className="htd-howto__card-head"
                  aria-expanded={isOpen}
                  aria-controls={`howto-body-${section.id}`}
                  onClick={() => openSection(section.id)}
                >
                  <span className="htd-howto__card-icon" aria-hidden>
                    <i className={section.icon} />
                  </span>
                  <span className="htd-howto__card-meta">
                    <span className="htd-howto__card-kicker">ขั้นตอนที่ {index + 1}</span>
                    <span className="htd-howto__card-title">{section.title}</span>
                    <span className="htd-howto__card-sub">{section.subtitle}</span>
                  </span>
                  <span className="htd-howto__card-chevron" aria-hidden>
                    <i className="fas fa-chevron-down" />
                  </span>
                </button>

                {isOpen && (
                  <div
                    id={`howto-body-${section.id}`}
                    className="htd-howto__card-body"
                    role="region"
                  >
                    <ol className="htd-howto__steps">
                      {section.steps.map((step, i) => {
                        const warning = isWarningStep(step)
                        return (
                          <li
                            key={i}
                            className={`htd-howto__step${warning ? ' is-warn' : ''}`}
                          >
                            <span className="htd-howto__step-num" aria-hidden>
                              {warning ? '!' : i + 1}
                            </span>
                            <p className="htd-howto__step-text">{cleanStepText(step)}</p>
                          </li>
                        )
                      })}
                    </ol>
                  </div>
                )}
              </article>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ModernHowtoPage
